import React, { Component, createRef } from 'react'
import { Nav } from 'react-bootstrap'

import './Menu.scss'
import { ReactComponent as HelpIcon } from '../assets/icons/help.svg'
import { openInNewTab } from '../Utils'
import { helpURL } from '../App.config'
import { simMod } from '../Module.config'

import { IconButton } from '../styles/Buttons'
import { AboutDialog } from './AboutDialog'
interface State {
    visible: boolean
    showAbout: boolean
}

export default class HelpMenu extends Component<any, State> {
    helpMenu = createRef<HTMLDivElement>()

    state: State = {
        visible: false,
        showAbout: false
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClick)
    }

    handleClick = (event: any) => {
        event.preventDefault()
        const eventTarget = event.target as HTMLDivElement
        const wasOutside = this.helpMenu.current && !this.helpMenu.current.contains(eventTarget)
        if (wasOutside) {
            this.hideMenu()
        }
    }

    setShowAbout = (value: boolean) => {
        this.setState({ showAbout: value })
    }

    hideMenu() {
        document.removeEventListener('click', this.handleClick)
        this.setState({ visible: false, })
    }

    showMenu(event: React.MouseEvent) {
        event.preventDefault()
        this.setState({
            visible: true
        })
        document.addEventListener('click', this.handleClick)
    }

    render() {
        const { visible, showAbout } = this.state

        return (
            <div ref={this.helpMenu}>
                <Nav.Link>
                    <IconButton onClick={(event: React.MouseEvent) => this.showMenu(event)}>
                        <HelpIcon />
                    </IconButton>
                </Nav.Link>

                {
                    visible && (
                        <div className="menu offset">
                            <div className="menu--option disabled">{'Help Options'}</div>
                            <div className="menu--separator" />
                            <div
                                className="menu--option"
                                onClick={(e: React.MouseEvent) => {
                                    this.hideMenu()
                                    simMod.moduleHelpURL ? openInNewTab(simMod.moduleHelpURL) : openInNewTab(helpURL)
                                }}>
                                {'Program Help'}
                            </div>

                            <div
                                className="menu--option"
                                onClick={(e: React.MouseEvent) => {
                                    this.hideMenu()
                                    this.setShowAbout(true)
                                }}>
                                {'About this module'}
                            </div>
                        </div>
                    )
                }
                <AboutDialog visible={showAbout} onHide={() => this.setShowAbout(false)} />
            </div>
        )
    }

}
